import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import PageTemplate from "./components/templates/PageTemplate";
import ScrollToTop from "./components/atoms/ScrollToTop";
import AuthCheck from "./components/pages/auth/AuthCheck";
import Popup from "./components/organisms/Popup";
import Alert from "./components/organisms/Alert"
import Confirm from "./components/organisms/Confirm"
import Toast from "./components/organisms/Toast";
import Guide from "./components/pages/Guide";
import Home from "./components/pages/Home";
import ReviewList from "./components/pages/review/ReviewList";
import ReviewDetail from "./components/pages/review/ReviewDetail";
import ReviewResultList from "./components/pages/review/ReviewResultList";
import ReviewResultDetail from "./components/pages/review/ReviewResultDetail";
import Login from "./components/pages/auth/Login";
import Logout from "./components/pages/auth/Logout";
import GroupList from "./components/pages/group/GroupList";
import GroupDetail from "./components/pages/group/GroupDetail";
import AdminGroupList from "./components/pages/admin/group/GroupList";
import AdminGroupDetail from "./components/pages/admin/group/GroupDetail";
import AdminGroupCreate from "./components/pages/admin/group/GroupCreate";
import AdminUserList from "./components/pages/admin/user/UserList";
import AdminReviewList from "./components/pages/admin/review/ReviewList";
import AdminReviewCreate from "./components/pages/admin/review/ReviewCreate";
import AdminReviewModify from "./components/pages/admin/review/ReviewModify";
import AdminReviewResultList from "./components/pages/admin/review/ReviewResultList";
import AdminReviewResultDetail from "./components/pages/admin/review/ReviewResultDetail";

function App() {
    const confirm = useSelector((state) => state.confirm);
    const alert = useSelector((state) => state.alert);
    const dispatch = useDispatch();

    return (
        <div className="App">
            <ScrollToTop />

            <Routes>
                {/* 로그인 인증 필요 없는 경로 */}
                <Route path="/" element={<Login />} />
                <Route path="/auth/logout" element={<Logout />} />

                {/* 로그인 인증 필요한 경로 */}
                <Route
                    element={
                        <AuthCheck>
                            <PageTemplate />
                        </AuthCheck>
                    }
                >
                    {/* 대시보드 */}
                    <Route path="/home" element={<Home />} />
                    {/* 리뷰 */}
                    <Route path="review/list" element={<ReviewList />} />
                    <Route path="review/detail/*" element={<ReviewDetail />} />
                    <Route path="review/result/list" element={<ReviewResultList />} />
                    <Route path="review/result/detail/*" element={<ReviewResultDetail />} />
                    {/* 그룹 */}
                    <Route path="group/list" element={<GroupList />} />
                    <Route path="group/detail/*" element={<GroupDetail />} />
                    {/* 관리 메뉴 */}
                    <Route path="admin/review/list" element={<AdminReviewList />} />
                    <Route path="admin/review/create" element={<AdminReviewCreate />} />
                    <Route path="admin/review/detail/*" element={<AdminReviewModify />} />
                    <Route path="admin/review/result/detail/*" element={<AdminReviewResultDetail />} />
                    <Route path="admin/group/list" element={<GroupList />} />
                    <Route path="admin/group/detail/*" element={<AdminGroupDetail />} />
                    <Route path="admin/group/create" element={<AdminGroupCreate />} />
                    <Route path="admin/user/list" element={<AdminUserList />} />
                    {/* 기타 */}
                    <Route path="guide" element={<Guide />} />
                </Route>

                {/* 그 외 경로는 로그인 화면으로 */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>

            <Popup />
            <Alert />
            <Confirm />
            <Toast />
        </div>
    );
}

export default App;